import { Card, Table, Input, Button, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { fetchData } from "../../utils";
import { useBlockScreen, useRoot } from "../../rootContext";
import moment from "moment";

const getColumns = () => [
    {
        title: "User Name",
        dataIndex: "UserName",
        key: "UserName",
    },
    {
        title: "Activity",
        dataIndex: "Activity",
        key: "Activity",
    },
    {
        title: "Description",
        dataIndex: "Description",
        key: "Description",
    },
    {
        title: "Date",
        dataIndex: "CreatedAtUtc",
        key: "CreatedAtUtc",
        render: (value) => moment(value).format("YYYY-MM-DD HH:mm:ss"),
    },
];

const UserActivityLog = () => {
    const blocker = useBlockScreen();
    const root = useRoot();
    const [pageData, setPageData] = useState({ data: [], total: 0 });
    const [loading, setLoading] = useState(false);
    const [pageInfo, setPageInfo] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [filters, setFilters] = useState({ userName: "" });

    const getData = ({ page, size, userName }) => {
        setLoading(true);

        let url = window.SiteBasePath + `/api/user/activities?page=${page}&size=${size}`;
        if (userName && userName.trim() !== "") {
            url += `&userName=${encodeURIComponent(userName.trim())}`;
        }

        fetchData(url, { blocker, root })
            .then((resp) => {
                setPageData({ data: resp.Data, total: resp.Count });
            })
            .finally(() => setLoading(false));
    };

    // 🔹 Load all logs on first render & whenever page changes
    useEffect(() => {
        getData({
            page: pageInfo.current - 1,
            size: pageInfo.pageSize,
            userName: filters.userName, // empty on first load → loads all logs
        });
    }, [pageInfo]);

    const handleSearch = () => {
        // Reset pagination to first page on search
        setPageInfo({ ...pageInfo, current: 1 });
        getData({ page: 0, size: pageInfo.pageSize, userName: filters.userName });
    };

    return (
        <Card style={{ marginTop: "20px" }}>
            <h4 style={{ marginBottom: "15px" }}>User Activity Logs</h4>

            {/* 🔎 Filter section */}
            <Row gutter={10} style={{ marginBottom: "15px" }}>
                <Col span={8}>
                    <Input
                        placeholder="Search by Username"
                        value={filters.userName}
                        onChange={(e) =>
                            setFilters({ ...filters, userName: e.target.value })
                        }
                        allowClear
                    />
                </Col>
                <Col>
                    <Button type="primary" onClick={handleSearch}>
                        Search
                    </Button>
                </Col>
            </Row>

            <Table
                loading={loading}
                rowKey="Id"
                pagination={{
                    total: pageData.total,
                    current: pageInfo.current,
                    pageSize: pageInfo.pageSize,
                }}
                onChange={(pagination) => {
                    setPageInfo({
                        ...pageInfo,
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                    });
                }}
                columns={getColumns()}
                dataSource={pageData.data}
                bordered
                size="small"
            />
        </Card>
    );
};

export default UserActivityLog;
